import { FC, useEffect, useState } from 'react'
import { PagedResponseModel } from '../../../../models/responses/PagedResponseModel'
import { IPaginationFilter } from '../../../../models/requests/PaginationFilter'
import { GenericTable } from '../../../components/tables/GenericTable'
import { TableHelperButtons } from '../../../components/buttons/TableHelperButtons'
import { TableHelperButtonEnum } from '../../../enums/TableHelperButtonEnum'
import { IAutoCommentModel } from '../../../../models/responses/AutoCommentModel'
import parse from 'html-react-parser'
import AutoCommentApi from '../../../../infrastructure/api/AutoCommentApi'
import { AutoCommentPointEnum } from '../../../../enums/AutoCommentPointEnum'
import { AutoCommentGroupEnum } from '../../../../enums/AutoCommentGroupEnum'

type Props = {
  onClickItem: (itemId: any, itemName: string, type: string) => void
  refresh: number
}

const AutoCommentListModal: FC<Props> = ({ onClickItem, refresh }) => {
  const [autoComments, setAutoComments] = useState<PagedResponseModel<IAutoCommentModel[]>>()
  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [searchText, setSearchText] = useState('')
  const [sort, setSort] = useState('date_desc')

  async function init() {
    const paginationFilter: IPaginationFilter = {
      page: pageNumber,
      size: pageSize,
      orderBy: sort,
      search: searchText,
    }
    var response = await AutoCommentApi.GetAutoComments(paginationFilter)
    setAutoComments(response.data)
  }

  useEffect(() => {
    init()
  }, [refresh, pageNumber, pageSize, searchText, sort])

  return (
    <>
      <GenericTable
        title='Auto Comments'
        data={autoComments?.items}
        currentTotalRecords={autoComments?.totalRecords!!}
        currentPageNumber={autoComments?.pageNumber!!}
        columns={[
          {
            label: '#',
            name: '#',
            options: {
              customBodyRenderLite: (dataIndex) => {
                return <>{(pageNumber - 1) * pageSize + ++dataIndex}</>
              },
              sort: false,
              viewColumns: false,
            },
          },
          {
            label: 'Message',
            name: 'message',
            options: {
              customBodyRender: (value) => {
                return <div className='d-flex align-items-center'>{parse(value)}</div>
              },
            },
          },
          {
            label: 'Group',
            name: 'group',
            options: {
              customBodyRender: (value) => {
                return <div className='d-flex align-items-center'>{AutoCommentGroupEnum[value].toString()}</div>
              },
            },
          },
          {
            label: 'Point',
            name: 'point',
            options: {
              customBodyRender: (value) => {
                return <div className='d-flex align-items-center'>{AutoCommentPointEnum[value].toString()}</div>
              },
            },
          },
          {
            label: '#',
            name: 'Id',
            options: {
              customHeadLabelRender: (options) => {
                return (
                  <div className='d-flex justify-content-end flex-shrink-0'>{options.label}</div>
                )
              },
              customBodyRenderLite: (dataIndex) => {
                return (
                  <TableHelperButtons
                    itemId={autoComments?.items[dataIndex]?.id!!}
                    itemParam={autoComments?.items[dataIndex]?.message!!}
                    types={[TableHelperButtonEnum.Update, TableHelperButtonEnum.Delete]}
                    onClickItem={onClickItem}
                  />
                )
              },
              filter: false,
              sort: false,
              viewColumns: false,
            },
          },
        ]}
        customOptions={{
          rowsPerPage: pageSize,
          customTableBodyFooterRender: (opts) => {
            return <div></div>
          },
        }}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        setSearchText={setSearchText}
        setSort={setSort}
      />
    </>
  )
}

export { AutoCommentListModal }
